var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Stack, Typography as MuiTypography } from '@mui/material';
export var Typography = function (_a) {
    var children = _a.children, _b = _a.startIcon, startIcon = _b === void 0 ? null : _b, _c = _a.classNameIcon, classNameIcon = _c === void 0 ? '' : _c, props = __rest(_a, ["children", "startIcon", "classNameIcon"]);
    var component = _jsx(MuiTypography, __assign({}, props, { children: children }));
    if (startIcon) {
        return (_jsxs(Stack, __assign({ className: classNameIcon, direction: "row", gap: 1, alignItems: "center" }, { children: [startIcon, component] })));
    }
    return component;
};
//# sourceMappingURL=Typography.js.map